import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  filterModel: null,
  quickFilterText: "",
  invoicesCache: {}, // New cache object
};

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setDates: (state, action) => {
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
    },
    setFilterModel: (state, action) => {
      state.filterModel = action.payload;
    },
    setQuickFilterText: (state, action) => {
      state.quickFilterText = action.payload;
    },
    saveInvoicesToCache: (state, action) => {
      const { key, data } = action.payload;
      state.invoicesCache[key] = data;
    },
    resetInvoicesState: () => initialState,
  },
});

export const {
  setDates,
  setFilterModel,
  setQuickFilterText,
  saveInvoicesToCache,
  resetInvoicesState,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;